module.exports = __webpack_public_path__ + "static/img/shouye1.5b06ad6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shouye/shouye1.png
// module id = hT3U
// module chunks = 17